// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"98":"53e2a3b31477ca62","2888":"61b802969fabc7cb"}[chunkId] + ".css";
};